import { Extension } from '@codemirror/state';
import { SxProps } from '@mui/system';
import { EditorView } from 'codemirror';

const FRONTEND_LANG = {
	react: 'react',
	webComponents: 'webComponents'
};

const BACKEND_LANG = {
	go: 'go',
	node: 'node',
	python: 'python'
};

const CODE_EDITOR_SUPPORTED_LANG = {
	...FRONTEND_LANG,
	...BACKEND_LANG,
	...{
		xml: 'xml',
		html: 'html',
		javascript: 'javascript',
		css: 'css',
		json: 'json'
	}
};

export type Lang =
	| typeof CODE_EDITOR_SUPPORTED_LANG.react
	| typeof CODE_EDITOR_SUPPORTED_LANG.webComponents
	| typeof CODE_EDITOR_SUPPORTED_LANG.go
	| typeof CODE_EDITOR_SUPPORTED_LANG.node
	| typeof CODE_EDITOR_SUPPORTED_LANG.python
	| typeof CODE_EDITOR_SUPPORTED_LANG.xml
	| typeof CODE_EDITOR_SUPPORTED_LANG.html
	| typeof CODE_EDITOR_SUPPORTED_LANG.javascript
	| typeof CODE_EDITOR_SUPPORTED_LANG.css
	| typeof CODE_EDITOR_SUPPORTED_LANG.json;

export interface ICodeEditorProps {
	id: string;
	value: string;
	editable: boolean;
	extensions: Extension[];
	theme: string;
	onChange: (s: string) => void;
	lang: Lang;
	refCallback?: (view: EditorManager) => void;
}

export interface ICodeEditorValue {
	id: string;
	value: string;
}

export interface ICodeEditorViewProps {
	id: string;
	editable: boolean;
	values: ICodeEditorValue[];
	currentTheme: string;
	onChange: (id: string, val: string) => void;
	lang: Lang;
	containerSx?: SxProps;
	refCallback?: (view: EditorManager) => void;
}

export type EditorManager =
	| (EditorView & { insertInCursor: (value: string) => void })
	| undefined;

export { FRONTEND_LANG, BACKEND_LANG, CODE_EDITOR_SUPPORTED_LANG };
